const screenStateEnum = Object.freeze({
  INITIAL: Symbol('INITIAL'),
  FINISHED: Symbol('FINISHED'),
});

export default screenStateEnum;
